import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const SumValidator = z.literal('sum');
export type TSumValidator = z.infer<typeof SumValidator>;

export const SumValidatorParamsSchema = z.object({
  target: z.number(),
  addendsPath: z.array(z.string()),
});

export type TSumValidatorParams = z.infer<typeof SumValidatorParamsSchema>;

export const SumValidatorSchema = BaseValidatorSchema.extend({
  type: SumValidator,
  value: SumValidatorParamsSchema,
});
